import { render, staticRenderFns } from "./guanli.vue?vue&type=template&id=daf089dc&scoped=true&"
import script from "./guanli.vue?vue&type=script&lang=ts&"
export * from "./guanli.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf089dc",
  null
  
)

export default component.exports